import { Component, Input } from '@angular/core';

@Component({
  selector: 'zikatagov-radio-button',
  template: `
    <div class="form-check">
      <input
        type="radio"
        class="form-check-input"
        [id]="id"
        [name]="name"
        [value]="value"
        [disabled]="disabled"
      />
      <label class="form-check-label" [for]="id">
        <ng-content></ng-content>
      </label>
    </div>
  `,
   standalone: true
})
export class ZikataRadioButtonComponent {
  @Input() id = '';
  @Input() name = '';
  @Input() value = '';
  @Input() disabled = false;
}
